import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=0bd65a9e&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=0bd65a9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd65a9e",
  null
  
)

export default component.exports